import { cn } from '@/lib/utils';

export const LoaderContainer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    {...props}
    className={cn(
      className,
      'absolute top-0 left-0 h-screen w-screen bg-white'
    )}
  />
);

export const LoaderBox = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    {...props}
    className={cn(className, 'flex h-3/4 items-center justify-center')}
  />
);
